import { SITE } from "../lib/site";
import { Sparkles, Layers, Heart } from "lucide-react";

const stats = [
  { icon: Layers, label: "DTF Print Specialists", v: "Direct-to-Film" },
  { icon: Sparkles, label: "Custom Designs", v: "1-of-1" },
  { icon: Heart, label: "Local Centreville, VA", v: "Made by Hand" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16">
        {/* Image with red offset */}
        <div className="md:col-span-5 relative">
          <div className="absolute -top-4 -left-4 md:-top-6 md:-left-6 w-full h-full border-2 border-[#FF2222]" aria-hidden="true" />
          <img
            src={SITE.media.about}
            alt="iza3nee Creations custom apparel studio in Centreville, Virginia"
            className="relative w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-700"
            loading="lazy"
          />
        </div>

        <div className="md:col-span-7 flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#FF2222]" />
            <span className="text-[11px] uppercase tracking-[0.3em] text-white/60">About the Brand</span>
          </div>

          <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            Made in Centreville.<br />
            <span className="text-[#FF2222]">Worn everywhere.</span>
          </h2>

          <p className="mt-8 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
            iza3nee Creations is a small-batch custom apparel studio rooted in Centreville, Virginia.
            We specialize in <strong className="text-white">DTF (Direct-to-Film) printing</strong> — a
            modern press technique that delivers bold, full-color graphics with a soft hand-feel that
            survives wash after wash.
          </p>
          <p className="mt-4 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
            From bridal parties and birthday tees to team spirit wear, family reunions, and one-of-one
            statement pieces — every order is pressed by hand with the same care we'd put on our own
            backs.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {stats.map((s) => (
              <div key={s.label} className="bg-[#050505] p-5">
                <s.icon size={18} className="text-[#FF2222] mb-3" />
                <div className="font-display text-xl uppercase text-white tracking-tight">{s.v}</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
